import React, { useState } from "react";
import RecipientList from "./RecipientList";
import { Tooltip } from "react-tooltip";
import { useTranslation } from "react-i18next";
import { useDrag } from "react-dnd";
import { textWidget } from "../../constant/Utils";

const PrefillWidgetCard = ({ widget }) => {
  const [, dragRef] = useDrag(
    () => ({
      type: "BOX",
      canDrag: !widget.disabled,
      item: {
        type: "BOX",
        id: `prefill-${widget.type}`,
        text: widget.type,
        isPrefill: true
      }
    }),
    [widget.type, widget.disabled]
  );

  return (
    <div className="mt-3 rounded border border-base-300 bg-base-100 p-3 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="flex-1">
          <p className="font-semibold text-base-content">{widget.title}</p>
          <p className="text-sm text-base-content/70">{widget.description}</p>
        </div>
        <button
          ref={dragRef}
          type="button"
          disabled={widget.disabled}
          className="op-btn op-btn-xs op-btn-outline flex items-center gap-1 cursor-grab disabled:cursor-not-allowed"
        >
          <i className="fa-light fa-grip-vertical"></i>
          Arrastrar
        </button>
      </div>
      {widget.helper && (
        <p className="mt-2 text-xs uppercase tracking-wide text-base-content/60">
          {widget.helper}
        </p>
      )}
      {widget.extra}
    </div>
  );
};

function SignerListPlace(props) {
  const { t } = useTranslation();
  const [showPrefillOptions, setShowPrefillOptions] = useState(false);
  const prefillWidgets = [
    {
      title: "Textbox",
      description:
        "Ingresa el texto que deseas mostrar dentro del cuadro. Haz clic en el ícono de configuración del componente para editar tamaño y color del texto.",
      helper:
        "Los campos prellenados están disponibles solo para el creador y son de solo lectura para los firmantes.",
      type: textWidget
    }
  ];
  return (
    <div>
      <div className="mx-2 pt-2">
        <button
          type="button"
          className="op-btn op-btn-sm op-btn-secondary w-full flex items-center gap-2"
          onClick={() => setShowPrefillOptions((prev) => !prev)}
        >
          <i className="fa-light fa-bolt"></i>
          Campos Prellenados
          <i
            className={`fa-light ${
              showPrefillOptions ? "fa-chevron-up" : "fa-chevron-down"
            } ml-auto text-xs`}
          ></i>
        </button>
        {showPrefillOptions && (
          <div className="mt-2 p-3 bg-base-200 rounded border border-base-300 text-sm space-y-2">
            <p className="font-semibold text-base-content">
              Solo el creador del documento puede editar los campos antes de
              enviar la solicitud.
            </p>
            {prefillWidgets.map((widget) => (
              <PrefillWidgetCard key={widget.title} widget={widget} />
            ))}
          </div>
        )}
      </div>
      <div className="mx-2 pr-2 pt-2 pb-1 text-[15px] text-base-content font-semibold border-b-[1px] border-base-300">
        <span className="relative">
          {props.title ? props.title : "Recipients"}
          <span className="absolute text-xs z-[30] mt-1 ml-0.5">
            {props?.title === "Roles" && (
              <>
                <a data-tooltip-id="my-tooltip">
                  <sup>
                    <i className="fa-light fa-question rounded-full border-[1px] border-base-content text-[11px] py-[1px] px-[3px]"></i>
                  </sup>
                </a>
                <Tooltip id="my-tooltip" className="z-[100]">
                  <div className="max-w-[450px] 2xl:max-w-[500px] p-[1px]">
                    <p className="font-bold pb-[1px]">{t("role-help.p1")}</p>
                    <p>{t("role-help.p2")} </p>
                    <p className="font-bold">{t("role-help.p3")}</p>
                    <p>{t("role-help.p4")}</p>
                    <p className="font-bold">{t("role-help.p5")}</p>
                    <p>{t("role-help.p6")}</p>
                  </div>
                </Tooltip>
              </>
            )}
          </span>
        </span>
      </div>
      <div className="overflow-auto hide-scrollbar max-h-[180px]">
        <RecipientList {...props} />
      </div>
      <div className="mx-1">
        {props.handleAddSigner ? (
          <div
            role="button"
            data-tut="reactourAddbtn"
            disabled={props?.isMailSend ? true : false}
            className="op-btn op-btn-accent op-btn-outline w-full mt-[14px]"
            onClick={() => props.handleAddSigner()}
          >
            <i className="fa-light fa-plus"></i> {t("add-role")}
          </div>
        ) : (
          <div
            role="button"
            data-tut="addRecipient"
            className="op-btn op-btn-accent op-btn-outline w-full mt-[14px]"
            disabled={props?.isMailSend ? true : false}
            onClick={() => props.setIsAddSigner(true)}
          >
            <i className="fa-light fa-plus"></i> {t("add-recipients")}
          </div>
        )}
      </div>
    </div>
  );
}

export default SignerListPlace;
